<app-offer-details-component [offerId]="selectedOfferId()" />
